import React from 'react'
import styled from 'styled-components'

import { Button, type ButtonStyles } from '@nexiahome/ui-common/components/primitives/buttons'

import Checkbox from 'components/Checkbox'
import Modal from 'components/Modal'
import { TermsAndConditions } from 'pages/TermsAndConditions/styles'

import Api from 'services/api'
import Honeybadger from 'honeybadger-js'
import { useSessionContext } from 'hooks/SessionContext'

import { color } from 'styles/colors'

type Props = {
  closeCallback: () => void
  navigateToBilling?: () => void
  hehmTermsUpToDate: boolean
}

const HEHMTermsAndConditionsModal = ({ closeCallback, navigateToBilling, hehmTermsUpToDate }: Props) => {
  const { session: { userName } } = useSessionContext()
  const [acceptedTerms, setAcceptedTerms] = React.useState(hehmTermsUpToDate || false)
  const [errors, setErrors] = React.useState({ acceptedTerms: '' })

  const handleSave = async () => {
    if (!acceptedTerms) {
      setErrors({ acceptedTerms: 'You must accept the terms and conditions to proceed.' })
      return
    }

    await Api.HomeHealth.acceptHehmTerms()
      .then(() => {
        navigateToBilling && navigateToBilling()
      })
      .catch(() => {
        Honeybadger.notify('Error accepting terms', { context: { username: userName } })
      })
  }

  return (
    <Modal variant="md" isDisplayed closeCallback={() => closeCallback()} title="" withHeaderBar>
      <TermsAndConditions>
        <h1>TERMS AND CONDITIONS</h1>

        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia perspiciatis nam doloribus, eius, itaque unde accusantium incidunt labore porro eveniet rem illum adipisci. Sed sit dolores iste velit excepturi voluptatum?</p>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia perspiciatis nam doloribus, eius, itaque unde accusantium incidunt labore porro eveniet rem illum adipisci. Sed sit dolores iste velit excepturi voluptatum?</p>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia perspiciatis nam doloribus, eius, itaque unde accusantium incidunt labore porro eveniet rem illum adipisci. Sed sit dolores iste velit excepturi voluptatum?</p>
        {!hehmTermsUpToDate && (
          <Checkbox
            label="I agree to the Terms & Conditions"
            checked={acceptedTerms}
            onChange={(e) => setAcceptedTerms(e.target.checked)}
            errorMessage={errors.acceptedTerms}
            variant="dark"
          />
        )}
      </TermsAndConditions>
      {!hehmTermsUpToDate ? (
        <S.ButtonContainer>
          <Button
            decoration="positive"
            text={'Submit'}
            onPress={handleSave}
            styles={UpgradeButtonStyle}
          />
        </S.ButtonContainer>
      ) : (
        <S.ButtonContainer>
          <Button
            decoration="positive"
            text={'Close'}
            onPress={closeCallback}
            styles={UpgradeButtonStyle}
          />
        </S.ButtonContainer>
      )}
    </Modal>
  )
}

export default HEHMTermsAndConditionsModal

const UpgradeButtonStyle: ButtonStyles = {
  button: { height: 35, borderRadius: 10, width: 100, backgroundColor: color('upgradeButton') },
  text: { textTransform: 'capitalize', fontWeight: 'bold' }
}

const S = {
  ButtonContainer: styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  `
}
